import { render, staticRenderFns } from "./usappbkpartnersver.vue?vue&type=template&id=0446237b&scoped=true&"
import script from "./usappbkpartnersver.vue?vue&type=script&lang=js&"
export * from "./usappbkpartnersver.vue?vue&type=script&lang=js&"
import style0 from "./usappbkpartnersver.vue?vue&type=style&index=0&id=0446237b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446237b",
  null
  
)

export default component.exports